import React, { Fragment, PureComponent } from 'react'
import PropTypes from 'prop-types'
import CSSModules from 'react-css-modules'
import classNames from 'classnames'
import Isvg from 'react-inlinesvg'

import { localize } from 'helpers/translator'
import navigationMenuContentTypes from 'helpers/enums/navigationMenuContentTypes'
import backIcon from 'assets/views/navigation_menu/back_icon.svg'

import styles from './view.scss'

class NavigationMenuNotificationPreferences extends PureComponent {

	navigateBack = () => this.props.navigateTo(navigationMenuContentTypes.MAIN)

	onEmailNotificationChange = ev => (
		this.props.updateEmailNotification(ev.target.checked)
	)

	render() {
		return (
			<Fragment>
				<div styleName='header' onClick={this.navigateBack}>
					<Isvg styleName='header-back' src={backIcon} cacheGetRequests={true} />
					<h1 styleName='header-title'>{localize('navigationMenu_notificationPreferences_label')}</h1>
				</div>
				<ul styleName='notification-list'>
					<li styleName='notification-list-item'>
						<label styleName={
							classNames({
								'notification-list-item-checkbox': true,
								'notification-list-item-checkbox--is-checked': this.props.isEmailNotificationEnabled,
							})
						}>
							<input
								type="checkbox"
								styleName='notification-list-item-checkbox-input'
								checked={this.props.isEmailNotificationEnabled}
								onChange={this.onEmailNotificationChange}
							/>
							<h2 styleName='notification-list-item-checkbox-title'>
								{localize('navigationMenu_notificationPreferences_enableEmailNotification_text')}
							</h2>
							<p styleName='notification-list-item-checkbox-description'>
								{localize('navigationMenu_notificationPreferences_enableEmailNotification_description')}
							</p>
						</label>
					</li>
				</ul>
				<p styleName='notification-text'>
					{localize('navigationMenu_notificationPreferences_note')}
				</p>
			</Fragment>
		)
	}
}

NavigationMenuNotificationPreferences.propTypes = {
	navigateTo: PropTypes.func,
	isEmailNotificationEnabled: PropTypes.bool,
	updateEmailNotification: PropTypes.func,
}

NavigationMenuNotificationPreferences.defaultProps = {
	navigateTo: () => {},
	isEmailNotificationEnabled: false,
	updateEmailNotification: () => {},
}


export default CSSModules(
	NavigationMenuNotificationPreferences, styles, {allowMultiple: true})
